export default {
	editSelected: 'Muuda valitud',
	label: 'Massimuutmine',
	warning: 'NB! See toiming kirjutab kõikide valitud seoste andmed üle.',
	warningRules: 'NB! Toimingu tulemusel muudetakse  meetmete kõik reeglid valitud staatusesse.',
}
